import '../pages/home.css';

function Contact() {
  return (
    <div className='contact'>
      <p className='contact-text'>
        Cualquier duda podés comunicarte por mail a:
      </p>
      <a className='contact-text' href="mailto:somosdatapruebas@gmail.com">somosdatapruebas@gmail.com</a>
    </div>
  );
};

export default Contact;